export const MUTATION_DELETE_OC_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteOperatingCostCase(id: $id)
	}
`;
